// extracted by mini-css-extract-plugin
export default {"dashboard":"e130f84f","dashboardPage":"c532b659"};